/**
 * Documentation KFP API
 * ## Common Request Headers - Authorization (string `Bearer {AccessToken}`, if signed-in) - After the client has successfully obtained `AccessToken` via Login, it\'s sent in every request as a bearer token.
 *
 * The version of the OpenAPI document: 1
 * Contact: novak@techcrowd.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionItemsResource } from './subscriptionItemsResource';


export interface SubscriptionsResource { 
    id: number;
    name: string;
    stripeId?: string;
    stripeStatus?: string;
    stripePrice?: string;
    quantity?: number;
    isCanceled?: boolean;
    isCourse?: boolean;
    trialEndsAt?: string;
    endsAt?: string;
    currentPeriodEnd?: string;
    /**
     * Aktuální sleva
     */
    discountAmount?: number | null;
    /**
     * Kód slevy
     */
    discountCode?: string | null;
    items?: Array<SubscriptionItemsResource>;
}

